export default (arr, arr2) => arr.filter(i => arr2.indexOf(i) < 0)



/** WEBPACK FOOTER **
 ** ./client/lib/arrayDiff.js
 **/